import { render, staticRenderFns } from "./bookiklanbaris.vue?vue&type=template&id=5eba043d"
import script from "./bookiklanbaris.vue?vue&type=script&lang=js"
export * from "./bookiklanbaris.vue?vue&type=script&lang=js"
import style0 from "./bookiklanbaris.vue?vue&type=style&index=0&id=5eba043d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports